module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin_cyrillic-300.5374c196.eot";